import axios from 'axios'
import { host } from './base.api.js'

/**
 * 活动相关接口地址
 */
const urls = {
  /**
   * 获取活动列表
   */
  activityList: host + '/api/socialagent/activity/list',
  /**
   * 获取活动详情
   */
  activityDetail: host + '/api/socialagent/activity/detail',
  /**
   * 获取所有省份列表
   */
  provinceList: host + '/api/socialagent/activity/provinces',
  /**
   * 获取省份下所有城市列表
   */
  provinceCityList: host + '/api/socialagent/activity/cities',
  /**
   * 获取最新代理人奖励信息
   */
  rewardList: host + '/api/socialagent/activity/rewards',
  /**
   * 获取商品列表
   */
  productList: host + '/api/socialagent/activity/products',
  /**
   * 获取商品详情
   */
  productDetail: host + '/api/socialagent/activity/productdetail',
  /**
  * 获取分享海报
  */
  getSharePoster: host + '/api/socialagent/activity/qrshareimage',
  /**
  * 获取信息补传接口
  */
  getComplete: host + '/api/socialagent/user/getComplete',
  /**
   *
 * 获取已经登录的信息补传接口
 */
  getLoginComplete: host + '/api/socialagent/user/getLoginComplete',
  /**
   * 根据城市id获取城市名称
   */
  getCityNameByCityId: host + '/api/socialagent/activity/getCityById',
}

export default {
  /**
   * 获取活动列表
   * @param {Number} cityId 城市ID
   * @param {Number} pvAreaId PvAreaId
   */
  getActivityList({ cityId = 0, pvAreaId = 0, pageSize = 0, pageNum = 0 }) {
    return axios.get(urls.activityList, {
      params: {
        cityId: cityId,
        pvAreaId: pvAreaId,
        pageSize,
        pageNum,
        t: new Date().getTime()
      }
    })
  },
  /**
   * 获取活动详情
   * @param {Number} platformActivityId 平台活动ID
   * @param {Number} pvAreaId PvAreaId
   * @param {Number} cityId
   */
  getActivityDetail({ platformActivityId = 0, pvAreaId = 0, cityId, popupseriesid, popuptype, popuppvid }) {
    console.log('getActivityDetail', platformActivityId)
    return axios.get(urls.activityDetail, {
      params: {
        platformActivityId: platformActivityId,
        pvAreaId: pvAreaId,
        popupseriesid,
        popuptype,
        popuppvid,
        cityId,
        t: new Date().getTime()
      }
    })
  },
  /**
   * 获取省份列表
   */
  getProvinceList() {
    return axios.get(urls.provinceList, {
      params: {
        t: new Date().getTime()
      }
    })
  },
  /**
   * 获取省份城市列表
   * @param {Number} provinceId 省份ID
   */
  getProvinceCityList(provinceId) {
    return axios.get(urls.provinceCityList, {
      params: {
        provinceId: provinceId,
        t: new Date().getTime()
      }
    })
  },
  // 获得轮播奖励数据
  getRewardList({ pvAreaId = 0 }) {
    return axios.get(urls.rewardList, {
      params: {
        pvAreaId: pvAreaId,
        t: new Date().getTime()
      }
    })
  },
  /**
   * 获取商品列表
   * @param {Number} cityId 城市ID
   * @param {Number} pvAreaId PvAreaId
   */
  getProductList({ cityId = 0, pvAreaId = 0, pageSize = 0, pageNum = 0 }) {
    return axios.get(urls.productList, {
      params: {
        cityId: cityId,
        pvAreaId: pvAreaId,
        pageSize,
        pageNum,
        t: new Date().getTime()
      }
    })
  },
  /**
   * 获取商品详情
   * @param {Number} goodsId 商品ID
   * @param {Number} pvAreaId PvAreaId
   */
  getProductDetail({ platformActivityId = 0, pvAreaId = 0 }) {
    return axios.get(urls.productDetail, {
      params: {
        platformActivityId: platformActivityId,
        pvAreaId: pvAreaId,
        t: new Date().getTime()
      }
    })
  },
  /**
  * 获取分享海报
  * @param {Number} platformActivityId 活动ID
  * @param {Number} pvAreaId PvAreaId
  * @param {Number} platformAgentId 代理人Id
  * @param {Number} customerId 同活动id => customerId
  * @param {Number} cityId
  */
  getSharePosterUrl({ platformActivityId, pvAreaId, platformAgentId, customerId, currentIndex, cityId, popupseriesid, popuptype, popuppvid, }) {
    return axios.get(urls.getSharePoster, {
      params: {
        PvAreaId: pvAreaId,
        PlatformAgentId: platformAgentId,
        CustomerId: customerId,
        platformActivityId: platformActivityId,
        currentIndex: currentIndex,
        popupseriesid,
        popuptype,
        popuppvid,
        cityId
      },
      responseType: 'blob'
    })
  },
  getComplete({ pvareaId, mobile }) {
    return axios.get(urls.getComplete + '?' + `pvareaId=${pvareaId}&mobile=${mobile}`)
  },
  getLoginComplete({ pvareaId }) {
    return axios.get(urls.getLoginComplete + '?' + `pvareaId=${pvareaId}`)
  },
  getCityNameByCityId(cityId) {
    return axios.get(urls.getCityNameByCityId + `?cityId=${cityId}`)
  },
}



// WEBPACK FOOTER //
// ./src/api/activity.js